export default "__VITE_ASSET__acDkWVvv__"